import { useTranslation } from 'react-i18next'
import type { PurposeBadgeData } from '../derivePurposeBadge'

interface Props {
  data: PurposeBadgeData
}

export function PurposeBadge({ data }: Props) {
  const { t } = useTranslation('coaching')
  if (!data) return null
  const label =
    data.kind === 'quiz'
      ? t(`purpose.quiz.${data.purpose}`)
      : t(`purpose.toon.${data.toonType}`)
  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium bg-indigo-50 text-indigo-700 border border-indigo-100"
      aria-label={label}
    >
      {label}
    </span>
  )
}
